module.exports = __webpack_public_path__ + "assets/img/profile-role.90655c87.svg";